module.exports = __webpack_public_path__ + "static/media/team-7.1380c1f1.jpg";